import { Group } from 'components/UIComponents/GroupMultiSelect';
import { useAllUsers } from 'hooks/useAllUsers';
import { ComponentProps, useMemo } from 'react';
import { FetchStatus } from 'types/fetch-status.types';
import { SingleGroupMultiSelectWithLabel } from './SingleGroupMultiSelectWithLabel';

type Props = Omit<
  ComponentProps<typeof SingleGroupMultiSelectWithLabel>,
  'dropdownItems'
>;

export const SingleUsersMultiselectWithLabel = (props: Props) => {
  const user = useAllUsers();

  const isFetching = user.status === FetchStatus.Fetching;

  const dropdownItems: Group[] = useMemo(() => {
    const options: Group['options'] =
      user.data?.map((r) => ({
        label: `${r.firstName} ${r.lastName}`,
        value: `${r.id}`,
        checked: false,
      })) ?? [];

    return [{ label: 'Users', value: 'users', options }];
  }, [user.data]);

  return (
    <SingleGroupMultiSelectWithLabel
      {...props}
      loading={isFetching}
      dropdownItems={dropdownItems}
    />
  );
};
